import * as React from "react";
import { AdvancedSearchEvent, BooleanSearchForm } from "../../BooleanSearchForm";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { LS2PacSearchDatabaseManager } from "@tlc/ls2pac/app/managers/SearchDatabaseManager";
import { LS2PAC_CONSTANTS } from "src/main/resources/js/main/constants";
import { TLCEventManager } from "../../../events/EventManager";

export const BooleanSearchPage: React.FC = () => {
    const { locationConfiguration: {pacSettings} = { pacSettings: null }} = useLocationConfiguration();

    const handleAdvancedSearchEvent = (event: AdvancedSearchEvent) => {
      const db = LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
        LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
          db
        );
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch, {...event, databaseKey: db});
      }
  
    return (<BooleanSearchForm allowTagging={pacSettings?.userActionSettings?.allowTagging} onClickSearch={handleAdvancedSearchEvent}></BooleanSearchForm>);
}